import { render, staticRenderFns } from "./boardissueview.vue?vue&type=template&id=27b53aaa&scoped=true&"
import script from "./boardissueview.vue?vue&type=script&lang=js&"
export * from "./boardissueview.vue?vue&type=script&lang=js&"
import style0 from "./boardissueview.vue?vue&type=style&index=0&id=27b53aaa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b53aaa",
  null
  
)

export default component.exports